import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";

export type SoldStats = {
  last24h: number;
  last7d: number;
  last30d: number;
};

export const getSoldStats = createServerFn({ method: "GET" }).handler(async (): Promise<SoldStats> => {
  const supabase = createClient(process.env.SUPABASE_URL!, process.env.SUPABASE_PUBLISHABLE_KEY!, {
    auth: { storage: undefined, persistSession: false, autoRefreshToken: false },
  });

  const now = Date.now();
  const d1 = new Date(now - 24 * 60 * 60 * 1000).toISOString();
  const d7 = new Date(now - 7 * 24 * 60 * 60 * 1000).toISOString();
  const d30 = new Date(now - 30 * 24 * 60 * 60 * 1000).toISOString();

  const [a, b, c] = await Promise.all([
    supabase.from("vehicle_snapshots").select("id", { count: "exact", head: true }).gte("sold_at", d1),
    supabase.from("vehicle_snapshots").select("id", { count: "exact", head: true }).gte("sold_at", d7),
    supabase.from("vehicle_snapshots").select("id", { count: "exact", head: true }).gte("sold_at", d30),
  ]);

  return {
    last24h: a.count ?? 0,
    last7d: b.count ?? 0,
    last30d: c.count ?? 0,
  };
});
